import { render, staticRenderFns } from "./NotificationHistorySelector.vue?vue&type=template&id=75b719e4&scoped=true"
import script from "./NotificationHistorySelector.vue.js?vue&type=script&lang=js&external"
export * from "./NotificationHistorySelector.vue.js?vue&type=script&lang=js&external"
import style0 from "./NotificationHistorySelector.vue?vue&type=style&index=0&id=75b719e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b719e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCheckbox})
